
















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Utils from '@/modules/Utils';
import PropUtils from '@/modules/PropUtils';
import { Reports } from '@/store';

@Component({})
class OverviewTab extends Vue {
    @Reports.Getter('commissioned_map') commissioned_map;

    @Prop() list;
    @Prop() total;

    PropUtils = PropUtils;

    getLocation(device){
        return Utils.deviceLocation(device);
    }
}

export default OverviewTab;
